var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 0H2.2C0.9867 0 0 0.9867 0 2.2V15.4C0 16.6133 0.9867 17.6 2.2 17.6H19.8C21.0133 17.6 22 16.6133 22 15.4V2.2C22 0.9867 21.0133 0 19.8 0ZM7.3865 4.4C8.6526 4.4 9.5865 5.3339 9.5865 6.6C9.5865 7.8661 8.6526 8.8 7.3865 8.8C6.1204 8.8 5.1865 7.8661 5.1865 6.6C5.1865 5.3339 6.1193 4.4 7.3865 4.4ZM11.473 13.2H3.3V12.6885C3.3 11.1782 5.1436 9.625 7.3865 9.625C9.6294 9.625 11.473 11.1782 11.473 12.6885V13.2ZM18.7 12.1H14.3V9.9H18.7V12.1ZM18.7 7.7H13.2V5.5H18.7V7.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriver);
export default __webpack_public_path__ + "static/media/ic-driver.6c771358bc2dfbf7390ce93381ad960e.svg";
export { ForwardRef as ReactComponent };